import { Button } from "@simplybusiness/mobius";
import { useSnowplowContext } from "@simplybusiness/services";
import type { FormEvent } from "react";
import { useTokensValues } from "../../../../hooks/tokens";
import { isStorybook } from "../../../../utils/storybook/isStorybook";
import type { Quote } from "../../types";

export const ActionsWithoutQdpDrawer = ({ quote }: { quote: Quote }) => {
  const { snowplow } = useSnowplowContext();
  const tokens = useTokensValues();

  if (!tokens) {
    return null;
  }

  function getSubmitterName(e: FormEvent<HTMLFormElement>) {
    const nativeEvent = e.nativeEvent as SubmitEvent;
    const submitter = nativeEvent.submitter as HTMLButtonElement;
    return submitter?.name;
  }

  function handleSubmit(e: FormEvent<HTMLFormElement>) {
    const submitterName = getSubmitterName(e);
    const snowplowEventName = {
      details_button_clicked: "detailsClicked",
      buy_button_clicked: "selectClicked",
    }[submitterName];

    if (snowplowEventName) {
      snowplow?.trigger(snowplowEventName);
    }

    if (isStorybook()) {
      e.preventDefault();
    }
  }

  return (
    <form
      method="POST"
      onSubmit={handleSubmit}
      className="mobius-quote-actions-form"
    >
      <div className="mobius-quote-actions">
        <input
          type="hidden"
          name="authenticity_token"
          value={tokens.authenticityToken}
        />
        <input type="hidden" name="journey_token" value={tokens.journeyToken} />
        <input type="hidden" name="quote_id" value={quote.id} />
        <input
          type="hidden"
          name="insurer"
          value={quote.covers[0]?.coverInsurer}
        />
        <Button
          type="submit"
          variant="secondary"
          className="mobius-quote-actions__button mobius-quote-actions__button--is-details"
          name="details_button_clicked"
          value="yes"
          size="sm"
        >
          Details
        </Button>
        <Button
          type="submit"
          name="buy_button_clicked"
          value="yes"
          className="mobius-quote-actions__button mobius-quote-actions__button--is-select"
          size="sm"
        >
          Buy
        </Button>
      </div>
    </form>
  );
};
